import { api } from "./configs/axiosConfigs"

export const PaymentVoucherAPI = {
    get: async (data?: object) => {
        const response = await api.get(
            '/payment-voucher', { params: data }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    cancel: async (id: number) => {
        const response = await api.patch(
            `/payment-voucher/cancel/${id}`
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
}